// extracted by mini-css-extract-plugin
export default {"container":"tou_EREJr"};